import styled from 'styled-components'

import Button from './Button'

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 21px;
  align-items: center;

  > h1 {
    font: var(--600-24);
  }

  > ${Button}:last-child {
    margin-left: auto;
  }
`
